var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircle = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 29,
  viewBox: "0 0 28 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "Subtract",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 28.5C21.732 28.5 28 22.232 28 14.5C28 6.76801 21.732 0.5 14 0.5C6.26801 0.5 0 6.76801 0 14.5C0 22.232 6.26801 28.5 14 28.5ZM13.9995 24.0785C19.2898 24.0785 23.5785 19.7898 23.5785 14.4995C23.5785 9.20921 19.2898 4.92057 13.9995 4.92057C8.70921 4.92057 4.42057 9.20921 4.42057 14.4995C4.42057 19.7898 8.70921 24.0785 13.9995 24.0785Z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircle);
export { ForwardRef as ReactComponent };